export const getApexDomain = ({
  editorStateSelectors
}) => {
  const {
    selectApexDomain
  } = editorStateSelectors;
  return selectApexDomain();
};